export const TEAK_ENTITY_NAMES = {
	DESK: 'TeakEntityWorkplace',
	ROOM: 'TeakEntityMeetingRoom',
	PARKING: 'TeakEntityParkingSpace',
	CUSTOM: 'TeakEntityCustom',
};
